import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AOS from 'aos';
import "./Homepages/Secondpage.css";
import "./Homepages/Homepage1.css";
import Landing from "./pages/Landing";
import Navbar from "./component/Navbar";
import Footer from "./component/Footer";
import Statistics from "./pages/Statistics";
import Services from "./pages/Services";
import Tenders from "./pages/Tenders";
import RTI from "./pages/RTI";
import Gallery from "./pages/Gallery";
import ContactUs from "./pages/ContactUs";
import AboutPage from "./pages/About";
import WarehouseDashboard from "./pages/WarehouseDashboard";
import AdminPage from "./pages/AdminPage";
import Reports from './pages/Reports';
// import Translate from './pages/Translate';


function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  return (
    <BrowserRouter>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />

        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/statistics" element={<Statistics />} />
            <Route path="/services" element={<Services />} />
            <Route path="/tenders" element={<Tenders />} />
            {/* <Route path="/documents" element={<Documents />} /> */}
            <Route path="/rti" element={<RTI />} />
            <Route path="/gallery" element={<Gallery />} />
            {/* <Route path="/other-links" element={<OtherLinks />} /> */}
            <Route path="/contact-us" element={<ContactUs />} />

            {/* dashboard */}
            <Route path="/warehouse-dashboard" element={<WarehouseDashboard />} />
            <Route path="/warehouse-Admin" element={<AdminPage />} />
            <Route path="/warehouse-Admin/report" element={<Reports />} />
          </Routes>
        </main>

        <Footer />

      </div>
    </BrowserRouter>

  );
}

export default App;


// import React from 'react';
// import Translate from './pages/Translate';

// function App() {
//   return (
//     <div>
//       <Translate />  {/* Language switcher appears here */}

//       <h1>Welcome to my website</h1>
//       <p>This content will automatically translate to Tamil or English.</p>

//       <h2>About Us</h2>
//       <p>We provide awesome services for everyone.</p>
//     </div>
//   );
// }
// export default App;